import React from "react";
import { TabContent, TabPane } from "reactstrap";
import { MaterialData } from "../../../../Data/UiKits/Tabs";
import { SimpleTabContentProp } from "../../../../Types/UiKitsType";

const MaterialStyleContent: React.FC<SimpleTabContentProp> = ({ tabId }) => {
  return (
    <TabContent activeTab={tabId}>
      {MaterialData &&
        MaterialData.map((item, index) => (
          <TabPane className={`fade ${tabId === item.id ? "show" : ""}`} tabId={item.id} key={index}>
            {item.text}
          </TabPane>
        ))}
    </TabContent>
  );
};
export default MaterialStyleContent;
